import { InsightType } from "types/graphql-schema";

export const requestTypes = [InsightType.FeedbackRequest];
